import { Grid, Card, Tooltip, Rating } from "@mui/material";
import React from "react";
import { SecurityEyeIcon, TimeCalendarIcon } from 'component/commonComponents/Icon';
import { StyledKBArticleCard } from "./kbArticleCard.style";
import Highlighter from 'react-highlight-words';
import { convertToShortNumber } from "utils/functions";
import { handleKeyPress } from "utils/functions";

export interface IKBArticleCardProps{
  /**
   * Type of card
   */
  type: string;
  /**
   * kbNumber
   */
  kbNumber: string;
  /**
   * Title of card
   */
  title: string;
  /**
   * Description of card
   */
  description: string;
  /**
   * Rating
   */
  rate: number;
  /**
   * lastUpdated
   */
  lastUpdated: string;
  /**
   * viewCount
   */
  viewCount: number;
  /**
   * Optional click handler
   */
  onViewDetail: () => void;
  onHomePage?:boolean;
  keywords?: string[];
  /**
   * Convert number greater than 1000+ should be show style 1K
   */
  isConvertViewCountToShortNumber?: boolean;
  /**
   * Show Tooltip for View Count
   */
  isShowViewCountTooltip?: boolean;  
  /**
   * Add spacing between short number
   */
  isShowViewCountShortNumberSpacing?: boolean;
  locale?: {
    view: string;
    views: string;
    lastUpdated: string;
  };
}

const KBArticleCard = (props : IKBArticleCardProps) => {
  let {
    title,
    rate,
    lastUpdated,
    viewCount,
    onViewDetail,
    onHomePage,
    keywords = [],
    isConvertViewCountToShortNumber,
    isShowViewCountTooltip,
    isShowViewCountShortNumberSpacing,
    locale,
  } = props;

  const clearSelection = () => {
    const selection = window.getSelection();
    if (selection) {
      selection.empty();
    }
  };

  return (
    <StyledKBArticleCard onDragStart={clearSelection} tabIndex={0} onKeyDown={(e: any) => handleKeyPress(e, "Enter", onViewDetail)}>
      <Card className="uptime-accordion-details" onClick={onViewDetail}>
        <Grid spacing={1} container>
          <Grid justifyContent="space-between" alignItems="center" container item xs={12} lg={onHomePage ? 6 : 8}>
            <Tooltip title={title} placement="top-start">
              <div className="title select-all-text" id="lbl-kbarticlecard-title">{<Highlighter highlightClassName="activeHighlight" searchWords={keywords} textToHighlight={title} autoEscape={true} />}</div>
            </Tooltip>
          </Grid>
          <Grid alignItems="center" container item xs={12} lg={onHomePage ? 6 : 4}>
            <Grid container item xs={4}>
              <Rating
                className="rate"
                name="size-small"
                defaultValue={rate}
                size="small"
                readOnly
                id="rtg-kbarticlecard-rating"
                precision={0.5}
              />
            </Grid>
            <Grid container item xs={3} alignItems="center" role="img" aria-label={`${viewCount} ${viewCount > 1? locale?.views : locale?.view}`}>
              <SecurityEyeIcon className="icons" alt="imageCard" role="presentation" aria-hidden="true" focusable="false" />
              <Tooltip title={isShowViewCountTooltip ? viewCount : ""} placement="top-start">
                <div className="viewcount" id="lbl-kbarticlecard-view_count" role="presentation">
                  ({isConvertViewCountToShortNumber ? convertToShortNumber(viewCount, { spacing: isShowViewCountShortNumberSpacing }) : viewCount})
                </div>
              </Tooltip>
            </Grid>
            <Grid container item xs={5} alignItems="center" role="img" aria-label={`${locale?.lastUpdated} ${lastUpdated}`}>
              {lastUpdated && (
                <>
                  <TimeCalendarIcon className="icons" alt="imageCard" role="presentation" aria-hidden="true" focusable="false"/>
                  <div className="lastupdated" id="lbl-kbarticlecard-last_updated" role="presentation">
                    {lastUpdated}
                  </div>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </StyledKBArticleCard>
  );
};


export default KBArticleCard;
